import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const getCallerLovedOneIdName = async (phoneNumber: string) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      phoneNumber,
    },
    query: graphql(`
      query GetCallerLovedOneIdName($phoneNumber: String!) {
        getCallerLovedOneIdName(phoneNumber: $phoneNumber) {
          callerId
          callerFirstName
          callerLastName
          lovedOneId
          lovedOneFirstName
          lovedOneLastName
          partnerId
        }
      }
    `),
  });

  return response.data?.getCallerLovedOneIdName ?? null;
};
